import React, { useState } from 'react'
import { AlternativeSystemPrompt } from '../chatApi'
import { Button } from './Buttons'
import { PromptDropdownSelect } from './PromptDropdownSelect'
import { Dialog } from './Dialog'
import SmartToy from '@mui/icons-material/SmartToy'
import { t, translatePersonalityName } from '../i18n'
export type SystemPromptSelectorProps = {
  alternativeSystemPrompts: AlternativeSystemPrompt[]
  canUseCustomSystemPrompt: boolean
  customSystemPrompt: string | null
  selectedSystemPromptId: string | null
  setCustomSystemPrompt: (customSystemPrompt: string | null) => void
  setSelectedSystemPromptId: (customSystemPromptId: string | null) => void
}

export const SystemPromptSelector = (props: SystemPromptSelectorProps) => {
  const [isOpen, setIsOpen] = useState(false)
  const [tempPrompt, setTempPrompt] = useState<string | null>(
    props.customSystemPrompt,
  )

  const openDialog = () => {
    setTempPrompt(props.customSystemPrompt)
    setIsOpen(true)
  }

  const closeDialog = () => {
    setIsOpen(false)
  }

  const savePrompt = () => {
    props.setCustomSystemPrompt(tempPrompt)
    props.setSelectedSystemPromptId(null)
    setIsOpen(false)
  }

  const selectedPrompt = props.alternativeSystemPrompts.find(
    (item) => item.prompt === tempPrompt,
  )

  return (
    <>
      <div className="flex items-center gap-2">
        {props.alternativeSystemPrompts.length >= 2 && (
          <PromptDropdownSelect
            options={props.alternativeSystemPrompts}
            onSelect={(item) => {
              props.setSelectedSystemPromptId(item.name)
            }}
            dropUp={true}
            selected={props.selectedSystemPromptId || undefined}
            customButtons={
              props.canUseCustomSystemPrompt
                ? [
                    {
                      onClick: openDialog,
                      text: t('custom'),
                    },
                  ]
                : []
            }
          >
            <SmartToy />{' '}
            {props.selectedSystemPromptId
              ? translatePersonalityName(props.selectedSystemPromptId)
              : t('custom')}
          </PromptDropdownSelect>
        )}
      </div>
      {isOpen && (
        <Dialog
          isOpen={isOpen}
          onClose={closeDialog}
          header={t('setSystemPrompt')}
        >
          {props.alternativeSystemPrompts.length >= 2 && (
            <div className={'flex gap-2 mb-2 items-center'}>
              <p>{t('choice')}</p>
              <div className={'flex gap-1'}>
                {props.alternativeSystemPrompts.map((item) => (
                  <Button
                    key={item.name}
                    size={'small'}
                    highlighted={
                      selectedPrompt && selectedPrompt.prompt === item.prompt
                    }
                    onClick={() => setTempPrompt(item.prompt || '')}
                  >
                    {translatePersonalityName(item.name)}
                  </Button>
                ))}
              </div>
            </div>
          )}
          <textarea
            rows={21}
            className={
              'w-full p-2 border-2 rounded bg-gray-50 dark:bg-gray-800 dark:border-gray-700 focus:outline-none focus:ring focus:border-blue-300 focus:border-2 focus:shadow-md'
            }
            placeholder={t('systemPromptPlaceholder')}
            value={tempPrompt || ''}
            onChange={(e) => setTempPrompt(e.target.value)}
          />
          <div className={'flex gap-2 justify-end'}>
            <Button onClick={closeDialog}>{t('cancel')}</Button>
            <Button onClick={savePrompt} variant={'primary'}>
              {t('save')}
            </Button>
          </div>
        </Dialog>
      )}
    </>
  )
}
